import {useDispatch} from 'react-redux';
import {bindActionCreators} from "redux";
import FormActions from "../../Actions/formActions";
import formHelpers from "../../Utils/Form/formUtils";

const useFormValidation = (form) => {
    const dispatch = useDispatch();
    const formActions = bindActionCreators(FormActions, dispatch);
    const onBlur = (field) => formActions.validateField(form, field);
        
    const field = (field) => {
        if (!form || !field) {
            return {};
        }
        return {
            onChange: (value) => formActions.changeAndValidateMultiFormField(form, field, value),
            onBlur: () => onBlur(field),
            error: form?.fieldErrorFlags?.[field],
            required: formHelpers.isRequired(form, field),
        }
    }

    return {
        field
    };
};

export default useFormValidation;
